import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "@/locales/en.json";
import es from "@/locales/es.json";
import fr from "@/locales/fr.json";
import pt from "@/locales/pt.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      fr: { translation: fr },
      pt: { translation: pt },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "es", "fr", "pt"],
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "lme_lang",
    },
    interpolation: { escapeValue: false },
  });

const setLang = (lng) => {
  document.documentElement.lang = lng;
};
setLang(i18n.resolvedLanguage || "en");
i18n.on("languageChanged", setLang);

export default i18n;
